import React, {PureComponent} from 'react';

import { Classes, Overlay, Collapse, Button, MenuItem } from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import toastr from "toastr";

export default class StripeReplacementModal extends PureComponent{
    render(){

        return(
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={()=>{this.props.handleClose();}}>
                                <i className="fas fa-times"></i>
                            </p>
                            <h2>PAYMENTS AND BILLING MANAGEMENT</h2>
                        </div>
                        {/*{console.log('Errors List: ', this.state.errorsList)}*/}
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>

                            </div>

                            <p>Payments and Billing Management on Emitto will be disabled for the next couple of days due to our migration to a new and more robust Billing management system.
                                <br/><br/>
                                We're super excited about this, since it will allow us to provide you with an even better customer service. 🏅
                                <br/><br/>
                                If you need to make a specific payment or top-up your account, please get in touch with our support team either via:<br/>
                                - intercom chat (in the bottom right), or<br/>
                                - send email to support@emitto.io<br/>
                                and we'll help you out with keeping your campaigns running without any impact.<br/><br/>

                                We want to thank you for your patience and understanding. 🙏</p>


                            <div className='flex-end'>
                                <button
                                    className='btn-transparent-border margin-bottom-30 margin-top-10'
                                    onClick={()=>{this.props.handleClose()}}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}